document.addEventListener('DOMContentLoaded', function () {
  var burger = document.querySelector('.header-custom__burger');
  var mobileNav = document.querySelector('.header-custom__nav-mobile');

  if (!burger || !mobileNav) return;

  burger.addEventListener('click', function () {
    var isOpen = mobileNav.classList.toggle('is-open');
    burger.classList.toggle('is-open', isOpen);
    burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });


// Scroll blur effect
window.addEventListener('scroll', function () {
  const header = document.querySelector('.header-custom');
  if (!header) return;
  
  if (window.scrollY > 100) {
    header.classList.add('is-scrolled');
  } else {
    header.classList.remove('is-scrolled');
  }
});

});
